export const CREATE_CHECKOUT_SESSION_ROUTE =
  "/api/stripe/create-checkout-session";

export const CREATE_CUSTOMER_PORTAL_SESSION_ROUTE =
  "/api/stripe/create-customer-portal-session";
